import { PlusCircleIcon } from '@heroicons/react/24/solid';
import { ButtonV2, Text } from '@cimplico/components';
import { PlusIcon } from '@heroicons/react/20/solid';

type BlankCardProps = {
    onCreate: () => void;
    disabled: boolean;
};
function BlankCard({ onCreate, disabled }: BlankCardProps): JSX.Element {
    return (
        <div className="p-4 border rounded" data-intercom-other-schedules-new-blank-card>
            <div className="flex flex-col h-full gap-2">
                <div className="flex items-center gap-1">
                    <PlusCircleIcon className="text-gray-400 h-4 w-4 shrink-0" />
                    <Text className="text-sm font-bold text-gray-800 ml-1">Blank Schedule</Text>
                </div>

                <Text className="text-xs text-gray-500" lines={2}>
                    Create a blank other schedule.
                </Text>

                <div className="flex items-start gap-2 border-t pt-2 mt-auto">
                    <span className="ml-auto">
                        <ButtonV2
                            size="xs"
                            label="Create"
                            leftIcon={<PlusIcon />}
                            type="secondary"
                            onClick={onCreate}
                            isDisabled={disabled}
                        />
                    </span>
                </div>
            </div>
        </div>
    );
}

export default BlankCard;
